import { EVENT_TYPE } from 'components/community/CreateAirmeetForm/constants';
import { TABLE_ROLE, USER_ROLE } from './constants/users';
import UserRoles from './userRoles';
import { includesRole } from './users';

const { HOST, COHOST, ORGANIZER, SPEAKER, EXHIBITOR, ATTENDEE } = USER_ROLE;
const { MODERATOR } = TABLE_ROLE;

export const RAISE_HAND = {
    REQUEST: 'REQUEST_RAISE_HAND',
    MANAGE: 'MANAGE_RAISE_HAND',
    VIEW: 'VIEW_RAISE_HAND',
    NEW_REQUEST_NOTIFICATION: 'RAISE_HAND_NEW_REQUEST_NOTIFICATION',
};

export const POLLS = {
    MANAGE: 'MANAGE_POLLS',
    VIEW: 'VIEW_POLLS',
};

export const ADVANCE_POLLS = {
    MANAGE: 'MANAGE_ADVANCE_POLLS',
};

export const STAGE_STREAM = {
    PUBLISH: 'PUBLISH_STAGE_STREAM',
};

export const COHOST_FEATURE = {
    MANAGE: 'MANAGE_COHOST_FEATURE',
};
export const STAGE_BACKDROP = {
    MANAGE: 'MANAGE_STAGE_BACKDROP',
};
export const STREAM_ACTION = {
    MANAGE: 'MANAGE_STREAM_ACTION',
};
export const INVITE_TO_STAGE = {
    MANAGE: 'MANAGE_INVITE_TO_STAGE',
};
export const REMOVE_MESSAGE = {
    MANAGE: 'MANAGE_REMOVE_MESSAGE',
};
export const BLOCK_USER = {
    MANAGE: 'MANAGE_BLOCK_USER',
};
export const PIN_COMMENT = {
    MANAGE: 'MANAGE_PIN_COMMENT',
};
export const QUESTION = {
    MANAGE: 'MANAGE_QUESTION',
};
export const LOUNGE = {
    MANAGE: 'MANAGE_LOUNGE',
};

export const ADDITIONAL_CONTROLS = {
    VIEW: 'VIEW_ADDITIONAL_CONTROLS',
};
export const DEVICE_CHOOSER = {
    VIEW: 'VIEW_DEVICE_CHOOSER',
};
export const REMOTE_VIDEO_PLAYER = {
    VIEW: 'VIEW_REMOTE_VIDEO_PLAYER',
};
export const STAGE_BACK_BUTTON = {
    VIEW: 'VIEW_STAGE_BACK_BUTTON',
};
export const STAGE_LAYOUT = {
    MANAGE: 'MANAGE_STAGE_LAYOUT',
};
export const LIVE_STAGE = {
    VIEW: 'VIEW_LIVE_STAGE',
};
export const MANAGE_ABUSE = {
    VIEW: 'VIEW_MANAGE_ABUSE',
};
export const SESSION_VIDEOS = {
    VIEW: 'VIEW_SESSION_VIDEOS',
};
export const USER_BLOCKABLE = {
    VIEW: 'VIEW_USER_BLOCKABLE',
};
export const GENERAL_ACTIONS_ON_EM = {
    VIEW: 'VIEW_GENERAL_ACTIONS_ON_EM',
};

export const HIDE_UNHIDE = {
    VIEW: 'VIEW_HIDE_UNHIDE',
};

export const USER_CARD_BADGE = {
    SHOW: 'SHOW_USER_CARD_BADGE',
};

export const USER_SYSTEM_DETAILS = {
    SHOW: 'SHOW_USER_SYSTEM_DETAILS',
};

export const STREAMING_SESSION = {
    MANAGE: 'STREAMING_SESSION_MANAGE',
};

export const HIDE_SHOW_USER = {
    VIEW: 'VIEW_HIDDEN_USER',
    MANAGE: 'MANAGE_HIDE_SHOW_USER',
};

const hostCohostFeatures = [
    COHOST_FEATURE.MANAGE,
    STAGE_BACKDROP.MANAGE,
    RAISE_HAND.MANAGE,
    INVITE_TO_STAGE.MANAGE,
    SESSION_VIDEOS.VIEW,
    MANAGE_ABUSE.VIEW,
    REMOTE_VIDEO_PLAYER.VIEW,
    HIDE_UNHIDE.VIEW,
    STREAM_ACTION.MANAGE,
];

const hostCohostSpeakerFeatures = [
    STAGE_STREAM.PUBLISH,
    POLLS.MANAGE,
    DEVICE_CHOOSER.VIEW,
    LIVE_STAGE.VIEW,
];

const hostCohostOrganizerFeatures = [
    REMOVE_MESSAGE.MANAGE,
    BLOCK_USER.MANAGE,
    PIN_COMMENT.MANAGE,
    QUESTION.MANAGE,
    USER_SYSTEM_DETAILS.SHOW,
    STREAMING_SESSION.MANAGE,
];

// Feature to Roles access map
const SESSION_FEATURE_ACCESS_ROLES = {
    [POLLS.VIEW]: [ORGANIZER, ATTENDEE],
    [ADVANCE_POLLS.MANAGE]: [HOST, ORGANIZER, COHOST],
    [RAISE_HAND.VIEW]: [HOST, COHOST, ORGANIZER, SPEAKER],
    [RAISE_HAND.NEW_REQUEST_NOTIFICATION]: [HOST, COHOST],
    [USER_BLOCKABLE.VIEW]: [ATTENDEE, EXHIBITOR],
    [GENERAL_ACTIONS_ON_EM.VIEW]: [HOST, COHOST, ORGANIZER, SPEAKER],
    [USER_CARD_BADGE.SHOW]: [HOST, COHOST, ORGANIZER, SPEAKER, MODERATOR],
    [STAGE_BACK_BUTTON.VIEW]: [ORGANIZER, ATTENDEE],
    [RAISE_HAND.REQUEST]: [ORGANIZER, ATTENDEE],
    [ADDITIONAL_CONTROLS.VIEW]: [HOST, COHOST],
    [HIDE_SHOW_USER.MANAGE]: [HOST, COHOST],
    [STAGE_LAYOUT.MANAGE]: [HOST, COHOST],

    // Feature access differ based on event type
};

(function populateSessionFeatureData() {
    // Features accessible to host and cohost
    hostCohostFeatures.forEach((feature) => {
        SESSION_FEATURE_ACCESS_ROLES[feature] = [HOST, COHOST];
    });

    // Features accessible to host, cohost and speaker
    hostCohostSpeakerFeatures.forEach((feature) => {
        SESSION_FEATURE_ACCESS_ROLES[feature] = [HOST, COHOST, SPEAKER];
    });

    // Features accessible to host, cohost and organizer
    hostCohostOrganizerFeatures.forEach((feature) => {
        SESSION_FEATURE_ACCESS_ROLES[feature] = [HOST, COHOST, ORGANIZER];
    });
})();

const EVENT_FEATURE_ACCESS_ROLES = {
    [LOUNGE.MANAGE]: [HOST, ORGANIZER],
    [ADVANCE_POLLS.MANAGE]: [HOST, ORGANIZER],
};

const getRoles = (
    feature,
    isSessionSpecific,
    accessVaryForEventType,
    isConferenceEvent = true
) => {
    const eventType = isConferenceEvent
        ? EVENT_TYPE.CONFERENCE
        : EVENT_TYPE.MEETUP;

    if (isSessionSpecific) {
        if (accessVaryForEventType) {
            return (
                (SESSION_FEATURE_ACCESS_ROLES[feature] &&
                    SESSION_FEATURE_ACCESS_ROLES[feature][eventType]) ||
                []
            );
        } else {
            return SESSION_FEATURE_ACCESS_ROLES[feature] || [];
        }
    } else {
        if (accessVaryForEventType) {
            return (
                (EVENT_FEATURE_ACCESS_ROLES[feature] &&
                    EVENT_FEATURE_ACCESS_ROLES[feature][eventType]) ||
                []
            );
        } else {
            return EVENT_FEATURE_ACCESS_ROLES[feature] || [];
        }
    }
};

/**
 * Util function to check the access of user for particular feature
 * @param {String} feature - Feature to check access for
 * @param {Object} data - Additional data (optional)
 */
export const hasAccess = (feature, data = {}) => {
    const {
        userId = null,
        role = null,
        accessVaryForEventType,
        sessionSpecific = true,
    } = data;

    const isSessionSpecific =
        !!SESSION_FEATURE_ACCESS_ROLES[feature] && sessionSpecific;

    const roles = getRoles(feature, isSessionSpecific, accessVaryForEventType);

    const userRole = role
        ? role
        : isSessionSpecific
        ? UserRoles.getUserSessionRole(userId)
        : UserRoles.getUserEventRole(userId);

    const accessRoles = Array.isArray(roles) ? roles : [];

    return includesRole(accessRoles || [], userRole);
};

export const isSessionHostOrCohost = (userId = null) => {
    const role = UserRoles.getUserSessionRole(userId);
    return includesRole([HOST, COHOST], role);
};

export const isHost = (userId = null) => {
    const role = UserRoles.getUserSessionRole(userId);
    return includesRole([HOST], role);
};

export const isCoHost = (userId = null) => {
    const role = UserRoles.getUserSessionRole(userId);
    return includesRole([COHOST], role);
};

export const isOrganizer = (userId = null) => {
    const role = UserRoles.getUserSessionRole(userId);
    return includesRole([ORGANIZER], role);
};

export const isSpeaker = (userId = null) => {
    const role = UserRoles.getUserSessionRole(userId);
    return includesRole([SPEAKER], role);
};

export const isAttendee = (userId = null) => {
    const role = UserRoles.getUserSessionRole(userId);
    return includesRole([ATTENDEE], role);
};

export const isExhibitor = (userId = null) => {
    const role = UserRoles.getUserSessionRole(userId);
    return includesRole([EXHIBITOR], role);
};

export const isEventAttendee = (userId = null) => {
    const role = UserRoles.getUserEventRole(userId);
    return includesRole([ATTENDEE], role);
};

export const isEventOrganizer = (userId = null) => {
    const role = UserRoles.getUserEventRole(userId);
    return includesRole([ORGANIZER], role);
};
